import React from "react";
import { action, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";

import { ImgLight } from "./Images/ImgLight";
import { ImgDark } from "./Images/ImgDark";

type ThemeTogglerProps = React.HTMLAttributes<HTMLButtonElement>;

@observer
class ThemeToggler extends React.Component<ThemeTogglerProps> {
  @observable private _currentTheme: 'light' | 'dark' = 'light';

  constructor(props: ThemeTogglerProps) {
    super(props);
    makeObservable(this);
  }
  
  componentDidMount() {
    const theme = document.documentElement.getAttribute('data-theme') || 'light';
    this._currentTheme = theme as 'light' | 'dark';
  }

  render() {
    return (
      <button className="theme-toggle" onClick={this._changeTheme} title="Toggle theme" {...this.props}>
        {this._currentTheme === 'light' ? <ImgLight /> : <ImgDark />}
      </button>
    );
  }

  @action.bound
  private _changeTheme = () => {
    //toggle data-theme attribute on html element
    const currentTheme = document.documentElement.getAttribute('data-theme');
    if (currentTheme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
    this._currentTheme = document.documentElement.getAttribute('data-theme') as 'light' | 'dark';
    localStorage.setItem('theme', this._currentTheme);
  }

}

export default ThemeToggler;